module.exports = __webpack_public_path__ + "8445acbf6808270ea626e416f85c6c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/tsp-og-bg.jpg
// module id = 1932
// module chunks = 0